<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20 7h-2.35A3.45 3.45 0 0018 5.5a3.49 3.49 0 00-6-2.44A3.49 3.49 0 006 5.5 3.45 3.45 0 006.35 7H4a1 1 0 00-1 1v13a1 1 0 001 1h16a1 1 0 001-1V8a1 1 0 00-1-1zm-1 6.5h-6V9h6zM14.5 4a1.5 1.5 0 010 3H13V5.5A1.5 1.5 0 0114.5 4zM8 5.5a1.5 1.5 0 013 0V7H9.5A1.5 1.5 0 018 5.5zM9.5 9H11v4.5H5V9zM5 15.5h6V20H5zm8 4.5v-4.5h6V20z"/></svg>